export default __webpack_public_path__ + "static/media/icon-logo-appstore.399e182c.png";